/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';
//foreman
import './assets/css/foreman.css';
import './assets/lib/bootstrap-daterangepicker/daterangepicker-bs3.css';
import './assets/lib/fullcalendar/dist/fullcalendar.css';
//import './assets/lib/ng-dialog/css/ngDialog.css';
//import './assets/lib/ng-dialog/css/ngDialog-theme-default.css';

import './assets/lib/moment/min/moment.min.js';
import './assets/lib/bootstrap-daterangepicker/daterangepicker.js';
import './assets/lib/ng-bs-daterangepicker/src/ng-bs-daterangepicker.js';
import './assets/lib/angular-ui-calendar/src/calendar.js';
import './assets/lib/fullcalendar/dist/fullcalendar.js';
import './assets/lib/fullcalendar/dist/gcal.js';
//import './assets/lib/ng-dialog/js/ngDialog.js';
require('./assets/lib/ng-file-upload/ng-file-upload.js');

import 'lodash';
//import './assets/lib/html2canvas/dist/html2canvas.js';

//import * as html2canvas from 'html2canvas';
const html2canvas = require('../node_modules/html2canvas');
console.log('including html2canvas');
window.html2canvas = html2canvas;
//import 'angular-moment-picker';
import 'angularjs-dropdown-multiselect';


// WEBPACK FOOTER //
// ./packages/custom/foreman/public/index.js